import { render, staticRenderFns } from "./xuqiuSq.vue?vue&type=template&id=1933f1b6&scoped=true"
import script from "./xuqiuSq.vue?vue&type=script&lang=js"
export * from "./xuqiuSq.vue?vue&type=script&lang=js"
import style0 from "./xuqiuSq.vue?vue&type=style&index=0&id=1933f1b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1933f1b6",
  null
  
)

export default component.exports